<template lang="pug" src="./custom-virtual-consultation-how.pug"></template>

<script>

export default {
  props: ['props']
}
</script>



// WEBPACK FOOTER //
// custom-virtual-consultation-how.vue?96d56838